/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Property } from 'csstype';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getStylist } from 'src/core/themes/luisStylist';

export type BarTooltipHeaderProps = {
    /**
     * The displayed header title.
     */
    title: string;
};

const messages = defineMessages({
    stackedBarTooltipTitleLabel: {
        id: 'analytics.predictionsPerIntentCard.stackedBarTooltipTitleLabel',
        defaultMessage: 'Name:'
    }
});

const { styleDiv, styleSpan } = getStylist('BarTooltipHeader');

const TooltipHeaderContainer = styleDiv('TooltipHeaderContainer', theme => ({
    backgroundColor: theme.backgroundColor,
    fontSize: theme.fontSize,
    color: theme.textColor,
    padding: theme.spacing,
    lineHeight: theme.lineHeight,
    letterSpacing: theme.letterSpacing
}));

const TitleLabel = styleSpan('TitleLabel', theme => ({
    fontWeight: theme.titleLabelFontWeight as Property.FontWeight
}));

const TitleContent = styleSpan('TitleContent', theme => ({
    fontWeight: theme.dataFontWeight as Property.FontWeight
}));

/**
 * The header of the bar tooltip.
 *
 * @param props The properties of the header.
 */
export const BarTooltipHeader = (props: BarTooltipHeaderProps) => {
    const { title } = props;
    const { localize } = useLocalization();

    return (
        <TooltipHeaderContainer>
            <TitleLabel>{localize(messages.stackedBarTooltipTitleLabel)}</TitleLabel>
            <TitleContent>{title}</TitleContent>
        </TooltipHeaderContainer>
    );
};
